module.exports = __webpack_public_path__ + "img/panele2.bd524010.jpg";